import { render, staticRenderFns } from "./PeopleOverview.vue?vue&type=template&id=5ace833a&scoped=true"
import script from "./PeopleOverview.vue?vue&type=script&lang=js"
export * from "./PeopleOverview.vue?vue&type=script&lang=js"
import style0 from "./PeopleOverview.vue?vue&type=style&index=0&id=5ace833a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace833a",
  null
  
)

export default component.exports